import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  CardDetailsView,
  CardFreightView,
  ContainerInputSearchAndButton,
  HeaderDashboard,
  ModalContainer,
  ModalOptions,
  ScrollBotton,
  ShippingCards,
  Sidebar,
  ThowColumLayout,
} from "../../components/index";

import { UserContext } from "../../context/User";
import api from "../../services/api";

const DashboardAdm = () => {
  const {
    permissionVisibility,
    getProfile,
    requestMade,
    setPermissionVisibility,
  } = useContext(UserContext);

  const navigate = useNavigate();

  // Estados principais
  const [modal, setModal] = useState(false);
  const [initial, setInitial] = useState(true);
  const [detailsTable, setDetailsTable] = useState(false);
  const [newTable, setNewTable] = useState(false);

  const [selectInput, setSelectInput] = useState("Rodoviário nacional");
  const [nameQuotation, setNameQuotation] = useState("");
  const [listDiscount, setListDiscount] = useState([]);
  const [listDiscountFreigth, setListDiscountFreigth] = useState([]);
  const [listDiscountVehicle, setListDiscountVehicle] = useState([]);
  const [routeDetails, setRouteDetails] = useState([]);
  const [listItens, setListItens] = useState([]);

  const [idDetails, setIdDetails] = useState("");
  const [nameDelete, setNameDelete] = useState("");
  const [idDelete, setIdDelete] = useState("");
  const [typeDelet, setTypeDelet] = useState("");
  const [loading, setLoading] = useState(false);

  // Estilos
  const containerStyles = {
    maxWidth: "1120px",
    padding: "2.6875rem 4.125rem 0 3.375rem",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginBottom: "20px",
    margin: "0 auto",
  };

  const boxCardStyles = {
    maxWidth: "1000px",
    display: "flex",
    gap: "21px",
    flexWrap: "wrap",
    marginTop: "36px",
    width: "100%",
  };

  // Funções de API
  const fetchDiscounts = async () => {
    try {
      setLoading(true);
      const [freightRes, vehicleRes] = await Promise.all([
        api.get("/quotations"),
        api.get("/vehicle"),
      ]);
      setListDiscountFreigth(freightRes.data);
      setListDiscountVehicle(vehicleRes.data);
    } catch (error) {
      showErrorToast(error);
    } finally {
      setLoading(false);
    }
  };

  const createTable = async (data) => {
    if (!data.length) {
      toast.error("Adicione ao menos um item na tabela", toastConfig());
      return;
    }

    try {
      if (selectInput === "Rodoviário dedicado") {
        await api.post("/type/vehicle", {
          name: nameQuotation,
          type: selectInput,
          users: listDiscount,
          data,
        });
        toast.info("Tabela de veículos criada!", toastConfig(5000));
      } else {
        await api.post("/quotations", {
          name: nameQuotation,
          type: selectInput,
          users: listDiscount,
          quotation: data,
        });
        toast.success("Tabela criada com sucesso!", toastConfig());
      }
      resetAfterAction();
    } catch (error) {
      showErrorToast(error);
    }
  };

  const updateTable = async (data) => {
    try {
      await api.patch(`/quotation/${idDetails}`, {
        name: nameQuotation,
        type: selectInput,
        users: listDiscount,
        quotation: data,
      });
      toast.info("Tabela atualizada com sucesso!", toastConfig());
      resetAfterAction();
    } catch (error) {
      showErrorToast(error);
    }
  };

  const deleteTable = async () => {
    try {
      const endpoint =
        typeDelet === "quotation"
          ? `/quotation/${idDelete}`
          : `/vehicle/${idDelete}`;
      await api.delete(endpoint);
      setModal(false);
      setNameDelete("");
      setIdDelete("");
      fetchDiscounts();
    } catch (error) {
      showErrorToast(error);
    }
  };

  const getDetails = async (id, typeOption, data = {}) => {
    setIdDetails(id);
    if (typeOption === "quotation") {
      setNameQuotation(data.name || "");
      setListDiscount(data.visibility || []);
      setSelectInput(data.type || "Rodoviário nacional");
      setRouteDetails(data.rota || []);
    } else {
      try {
        const response = await api.get(`/vehicle/${id}`);
        const { name, visibility, type } = response.data;
        setNameQuotation(name);
        setListDiscount(visibility);
        setSelectInput(type);
      } catch (error) {
        showErrorToast(error);
      }
    }
  };

  // Helpers
  const showErrorToast = (error) => {
    toast.error(
      error?.response?.data?.message || "Erro inesperado",
      toastConfig()
    );
  };

  const toastConfig = (autoClose = 2000) => ({
    position: "top-right",
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });

  const resetAfterAction = () => {
    setTimeout(() => {
      setNewTable(false);
      setInitial(true);
    }, 500);
  };

  // Sincronizar Scroll
  const syncScroll = () => {
    const div = document.getElementById("test");
    if (!div || !listItens.length) return;

    listItens.forEach((item) => {
      const divItem = document.getElementById(item);
      if (divItem) divItem.scrollLeft = div.scrollLeft;
    });
  };

  const handlePermissionControl = useCallback(async () => {
    if (requestMade) {
      if (!permissionVisibility) navigate("/dashboard/manage");
    } else {
      await getProfile();
    }
  }, [permissionVisibility, requestMade, navigate, getProfile]);

  // Efeitos
  useEffect(() => {
    handlePermissionControl();
  }, [handlePermissionControl]);

  useEffect(() => {
    const div = document.getElementById("test");
    div?.addEventListener("scroll", syncScroll);
    return () => div?.removeEventListener("scroll", syncScroll);
  }, [listItens]);

  useEffect(() => {
    setInitial(true);
  }, []);

  useEffect(() => {
    if (initial) {
      setNameQuotation("");
      setSelectInput("Rodoviário nacional");
      fetchDiscounts();
      setListDiscount([]);
    }
  }, [modal, initial, detailsTable, newTable]);

  // Renderizações separadas
  const renderCards = () => (
    <div style={boxCardStyles}>
      {loading
        ? Array(2)
            .fill()
            .map((_, index) => <ShippingCards key={index} loading={true} />)
        : listDiscountFreigth.map((item) => (
            <ShippingCards
              key={item.id}
              title={item.name}
              visibility={item.visibility}
              type={item.type}
              id={item.id}
              onClick={() => {
                setSelectInput(item.type);
                setInitial(false);
                setDetailsTable(true);
                getDetails(item.id, "quotation", item);
                setTypeDelet("quotation");
              }}
              openModal={() => {
                setNameDelete(item.name);
                setIdDelete(item.id);
                setModal(true);
                setTypeDelet("quotation");
              }}
            />
          ))}
      {loading
        ? Array(1)
            .fill()
            .map((_, index) => <ShippingCards key={index} loading={true} />)
        : listDiscountVehicle.map((item) => (
            <ShippingCards
              key={item.id}
              title={item.name}
              visibility={item.discouns}
              type={item.type}
              id={item.id}
              onClick={() => {
                setSelectInput(item.type);
                setInitial(false);
                setDetailsTable(true);
                getDetails(item.id, "vehicle");
                setTypeDelet("vehicle");
              }}
              openModal={() => {
                setNameDelete(item.name);
                setIdDelete(item.id);
                setModal(true);
                setTypeDelet("vehicle");
              }}
            />
          ))}
      <ModalContainer isActive={modal} closeModal={() => setModal(!modal)}>
        <ModalOptions
          nameDelete={nameDelete}
          isActive={modal}
          type="delete"
          closeModal={() => setModal(!modal)}
          onClick={deleteTable}
        />
      </ModalContainer>
    </div>
  );

  if (!permissionVisibility) return null;

  return (
    <ThowColumLayout
      page="DashboardAdm"
      colum1={<Sidebar page="DashboardAdm" access="adm" />}
      colum2={
        initial ? (
          <div
            style={{
              backgroundColor: "#F9F9F9",
              minHeight: "100vh",
            }}
          >
            <HeaderDashboard name="Tabelas de frete" adm />
            <div style={containerStyles}>
              <ContainerInputSearchAndButton
                excel
                table={null}
                onClick={() => {
                  setInitial(false);
                  setDetailsTable(false);
                  setNewTable(true);
                }}
              />
              {renderCards()}
            </div>
          </div>
        ) : detailsTable ? (
          <div style={{ backgroundColor: "#F9F9F9", minHeight: "100vh" }}>
            <HeaderDashboard
              back
              onClick={() => setInitial(true)}
              name="Detalhes da tabela"
              adm
            />
            <CardDetailsView
              id={idDetails}
              listDiscount={listDiscount}
              setListDiscount={setListDiscount}
              value={nameQuotation}
              details={{
                name: nameQuotation,
                visibility: listDiscount,
                type: selectInput,
                route: routeDetails,
              }}
              onChange={(e) => setNameQuotation(e.target.value)}
              valueSelect={selectInput}
              typeSelect={typeDelet}
              onChangeSelect={(e) => setSelectInput(e.target.value)}
            />
            <ScrollBotton width="8000px" />
            <CardFreightView
              type="update"
              typeRoute={selectInput}
              id={idDetails}
              onSubmit={updateTable}
              value={selectInput}
              typeSelect={typeDelet}
              setListItens={setListItens}
            />
          </div>
        ) : (
          <div style={{ backgroundColor: "#F9F9F9", minHeight: "100vh" }}>
            <HeaderDashboard
              back
              onClick={() => setInitial(true)}
              name="Nova tabela"
              adm
            />
            <CardDetailsView
              listDiscount={listDiscount}
              setListDiscount={setListDiscount}
              value={nameQuotation}
              onChange={(e) => setNameQuotation(e.target.value)}
              valueSelect={selectInput}
              onChangeSelect={(e) => setSelectInput(e.target.value)}
            />
            <ScrollBotton width="2850px" typeRoute={selectInput} />
            <CardFreightView
              typeRoute={selectInput}
              onSubmit={createTable}
              value={selectInput}
              setListItens={setListItens}
            />
          </div>
        )
      }
    />
  );
};

export default DashboardAdm;
